/*
 * @Date: 2022-08-23 17:19:47
 * @LastEditors: kinfai
 * @Description: 聊天列表
 * @LastEditTime: 2022-11-03 11:33:53
 * @FilePath: \chatPlugin\src\pages\ChatList\index.jsx
 */
import "./index.less";
import { Button, Avatar, Image } from "antd";
import AliIcon from "@/components/AliIcon";
import { UserOutlined, RightOutlined } from '@ant-design/icons';
import { useContext, Fragment, cloneElement, useState } from "react";
import { RouteContext } from "../../provide/route-context";
import useTurms from "../../hooks/turms/index.js";
import useChatPlugin from "@/hooks/chatPlugin/index.js";
import avatar1 from "../../assets/avatar/1.png";
import avatar2 from "../../assets/avatar/2.png";
import avatar3 from "../../assets/avatar/3.png";


export default function ChatList() {
    const context = useContext(RouteContext)
    const { initTurms } = useTurms()
    const {getPluginConfig} = useChatPlugin()
    const pageConfig = getPluginConfig()

    const startChat = () => {
        // todo - api - 随机客服
        context.goPage("ChatConversation")
    }

    const CustomerService = (props) => {
        const [loading, editLoad] = useState(false);

        const csList = [
            {
                img: avatar1,
                id: 1,
            },
            {
                img: avatar2,
                id: 2,
            },
            {
                img: avatar3,
                id: 3,
            },
        ];

        const newChildren = cloneElement(props.children, { onClick: startChat })

        const nextPage = async () => {
            editLoad(true)
            await initTurms()
            context.goPage("ChatConversation")
        }

        return (
            <div className="g-web-chat-card">
                {
                    props.children ? newChildren :
                        <Fragment>
                            <div className="g-cs-list">
                                <Avatar.Group>
                                    {csList.map((cs) => {
                                        const { id, img } = cs;
                                        return (
                                            <Avatar
                                                style={{
                                                    background: "grey",
                                                    border: "1px solid grey"
                                                }}
                                                size="large"
                                                key={id}
                                                src={img}
                                            />
                                        );
                                    })}
                                </Avatar.Group>
                                <div className="g-text-group">
                                    <p className="s-text1">Usual reply time</p>
                                    <p className="s-text2">within a few minutes</p>
                                </div>
                            </div>
                            <Button type="primary"
                                shape="round"
                                onClick={nextPage}
                                style={{
                                    height: '40px',
                                    background: pageConfig.btnColor
                                }}
                                loading={loading}
                            >
                                <span
                                    style={{
                                        marginRight: "15px",
                                    }}
                                >
                                    Start Chat
                                </span>
                                <AliIcon type="icon-fasong" size="20px" style={{
                                    marginBottom: "-15px"
                                }}></AliIcon>
                                {/* <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <span
                                        style={{
                                            marginRight: "15px",
                                        }}
                                    >
                                        Start Chat
                                    </span>
                                    <AliIcon type="icon-fasong" size="20px"></AliIcon>
                                </div> */}
                            </Button>
                        </Fragment>
                }
            </div>
        );
    };

    const ContinueChat = (props) => {
        const { lastMsgInfo } = context

        let msgContent = lastMsgInfo.value
        if (lastMsgInfo.type === 'img') {
            msgContent = '[pricture]'
        } else if (lastMsgInfo.type === 'levelMsgInfo') {
            msgContent = '[留言信息]'
        }

        return <div>
            <p className="s-continue-title">Continue the conversation</p>
            <div className="g-last-chat" onClick={props.onClick}>
                <div>
                    {
                        lastMsgInfo.avatar ?
                            <Avatar src={lastMsgInfo.avatar} />
                            : <Avatar icon={<UserOutlined />} />
                    }
                    <div className="g-last-chat-info">
                        <div className="s-name">{lastMsgInfo.userName}</div>
                        <div className="s-last-msg">{msgContent}</div>
                    </div>
                </div>
                <RightOutlined />
            </div>
        </div>
    }

    const Channel = () => {
        const config = [
            {
                icon: "icon-messenger",
                text: "Messenger",
            },
            {
                icon: "icon-instagram",
                text: "Instagram",
            },
        ];

        return config.map((chanel, index) => {
            return (
                <div className="g-card" key={index}>
                    <AliIcon type={chanel.icon} size="24px"></AliIcon>
                    <span className="s-title">{chanel.text}</span>
                </div>
            );
        });
    };

    return (
        <div className="g-chat-list">
            <CustomerService>
                {
                    context.csInfo.id !== 0 && <ContinueChat />
                }
            </CustomerService>
            {/*<div className="g-channels-box">*/}
            {/*  <p className="s-channels-text">Contact us from other channels</p>*/}
            {/*  <Channel />*/}
            {/*</div>*/}
        </div>
    );
}
